import axios from "axios";

const survivorDomainRecordApi = {
  fetchNPI: npi => axios.get(`/api/v1/survivorship_domain_record/${npi}`),
};

export default survivorDomainRecordApi;
